<template>
  <div>
    <h2>New QA user</h2>

    <form @submit.prevent="addQAUser">
      <div class="form-group">
        <label for="identityType">Id type</label>
        <select v-model="idType" id="identityType" class="form-control" required>
          <option :value="1">Player ID</option>
          <option :value="3">Ads ID</option>
        </select>
      </div>
      <div class="form-group">
        <label for="identityValue">Id value</label>
        <input v-model="idValue" id="identityValue" class="form-control" maxlength="64" required>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea
          v-model="description"
          id="description"
          class="form-control"
          rows="3"
          maxlength="128"
          required
        />
      </div>
      <b-button :to="{name: 'qa_users'}">Cancel</b-button>
      <b-button type="submit" variant="primary">Add</b-button>
    </form>
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

export default {
  name: 'QAUserAdd',

  data() {
    return {
      // See EnumQAUserIdentity for idType values.
      idType: 1,
      idValue: '',
      description: '',
    }
  },

  methods: {
    addQAUser() {
      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.set('id_type', this.idType.toString());
      data.set('id_value', this.idValue);
      data.set('description', this.description);

      HTTP.post('/qa_user/add', data)
      .then(() => {
        notifier.showSuccessAfterTransition('QA user added.');
        this.$router.push({name: 'qa_users'});
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
